import request from '../utils/request'
import { Tag } from '@/types/tag'

export function Create(tag: Tag): Promise<Tag[]> {
  return request.post('/tag', tag)
}

export function Find(): Promise<Tag[]> {
  return request.get('/tag')
}

export function Patch(id: number, tag: Tag): Promise<Tag> {
  return request.patch(`/tag/${id}`, tag)
}

export function Delete(id: number): Promise<Tag> {
  return request.delete(`/tag/${id}`)
}

export function getTags(): Promise<Tag[]> {
  return request.get('/tag')
}

export function getTagsGrouped() {
  return request({
    url: '/tag/group',
  })
}

export function getTagsValue() {
  return request({
    url: '/tags',
  })
}
